import { Schema, arrayOf } from 'normalizr'

export const marketSchema = new Schema('markets')
export const venueSchema = new Schema('venues')
export const ticketSchema = new Schema('tickets')
export const dealSchema = new Schema('deals')
export const groupSchema = new Schema('groups')
export const eventGroupSchema = new Schema('eventGroups')
export const performanceSchema = new Schema('performances')
export const setupformSchema = new Schema('setupforms')
export const eventTypeSchema = new Schema('eventTypes')
export const sellableItemSchema = new Schema('sellableItems')
export const sellableItemGroupSchema = new Schema('sellableItemGroups')
export const promoCodeSchema = new Schema('promoCodes')

export const partnerSchema = new Schema('partners')
export const partnerSettingsSchema = new Schema('partnerSettings', { idAttribute: (entity) => entity.partner.id })

/* Use mappedBy on the group schema - https://github.com/gaearon/normalizr/issues/70.
** mappedBy('group') adds the field `group` to all ticket objects
** e.g. if the API response returns:
**     {groups: [{id: 500, tickets: [1, 2]}]}
** then when normalising the tickets, normalizer add a reverse id relation (using the name `group`) to each ticket:
**     tickets: [{id: 1, firstName: 'Bob', group: 500}, {id: 2, firstName: 'Bill', group: 500}]
*/
groupSchema.define({
  tickets: arrayOf(ticketSchema).mappedBy('group'),
})

eventGroupSchema.define({
  market: marketSchema,
  venue: venueSchema,
  deals: arrayOf(dealSchema),
  performances: arrayOf(performanceSchema),
  sellableItems: arrayOf(sellableItemSchema),
})

performanceSchema.define({
  deals: arrayOf(dealSchema),
  tickets: arrayOf(ticketSchema),
  groups: arrayOf(groupSchema),
  eventGroup: eventGroupSchema.mappedBy('performances'),
})

partnerSettingsSchema.define({
  partner: partnerSchema,
})

partnerSchema.define({
  market: marketSchema,
})

setupformSchema.define({
  venue: venueSchema,
})



/** WEBPACK FOOTER **
 ** ./src/services/schemas/schemas.js
 **/